/*
  NOTE: THIS IS A TEMPORARY SOLUTION TO ALLOW FOLLOWING ON THE PROFILE PAGE
  UNTIL WE ARE ABLE TO IMPLEMENT THE NEW PROFILE EXPERIENCE. USING THIS COMPONENT WILL
  REQUIRE RUNNING THE APPLICATION WITH SSL IN DEVELOPMENT.
*/

import classNames from 'classnames';
import useUserConnectionActions from '../../../hooks/useUserConnectionActions';
import * as styles from './styles/styles.module.scss';
import FollowButton from '../FollowButton';
import BlockButton from '../BlockButton';
import CustomProvider from '../../CustomProvider';

type Props = {
  userId: number;
  otherUserId: number;
};

const SocialButtonGroup = ({ userId, otherUserId }: Props): JSX.Element => {
  const [userConnection, takeUserAction] = useUserConnectionActions(userId, otherUserId);

  return (
    <CustomProvider>
      <div className={styles.socialButtonsContainer}>
        <FollowButton userConnection={userConnection} takeUserAction={takeUserAction} className={styles.buttonBase} userId={userId} />
        <BlockButton
          userConnection={userConnection}
          takeUserAction={takeUserAction}
          className={classNames(styles.buttonBase, styles.blockButton)}
          userId={userId}
        />
      </div>
    </CustomProvider>
  );
};

export default SocialButtonGroup;
